/* Aromahain — motion 2026 v2. Nessuna libreria. Tutto disattivato con prefers-reduced-motion.
   - palco hero: profondità col puntatore (desktop), parallasse allo scroll, nebbia su canvas
   - titoli che salgono parola per parola, elementi [data-ah-rise]
   - bottoni magnetici (solo puntatore fine)
   - racconto "Drei Momente" fissato durante lo scroll
   - fascia nomi che scorre con la velocità dello scroll
   - immagini che si aprono con una tendina */
(() => {
  const html = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  html.classList.add('ah-m');
  if (reduce) { html.classList.add('ah-m-reduce'); }

  const lerp = (a, b, t) => a + (b - a) * t;
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const io = (cb, opts) => ('IntersectionObserver' in window ? new IntersectionObserver(cb, opts) : null);
  /* 01/10 velocità mobile: i loop animati partono dopo il caricamento (non competono col primo render)
     e scrivono le variabili CSS solo quando il valore cambia (ogni scrittura ricalcolava lo stile del blocco). */
  const afterLoad = (fn) => {
    const go = () => setTimeout(() => requestAnimationFrame(fn), 700);
    if (document.readyState === 'complete') go(); else addEventListener('load', go, { once: true });
  };
  const setVar = (el, k, v) => { const c = el.__ahv || (el.__ahv = {}); if (c[k] !== v) { c[k] = v; el.style.setProperty(k, v); } };

  document.querySelectorAll('.product-grid__item').forEach((el, i) => el.style.setProperty('--ah-i', i % 12));

  /* ---------- testo: parole che salgono ---------- */
  const splitSel = '[data-ah-split], .ahs-hd h2, .ahs-ed__copy h2, .ahs-end h2, .ahs-story__h2, .ahs-df__h2';
  const splitEls = [...document.querySelectorAll(splitSel)];
  splitEls.forEach((el) => {
    if (el.dataset.ahSplitDone) return;
    el.dataset.ahSplitDone = '1';
    const words = el.textContent.trim().split(/\s+/);
    el.setAttribute('aria-label', el.textContent.trim());
    el.innerHTML = words.map((w, i) => `<span class="ah-w" aria-hidden="true"><span style="--i:${i}">${w.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]))}</span></span>`).join(' ');
  });
  const showObs = io((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); showObs.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  const reveal = (el) => { if (!showObs) { el.classList.add('is-in'); return; } showObs.observe(el); };
  splitEls.forEach(reveal);
  document.querySelectorAll('[data-ah-rise]').forEach(reveal);

  /* immagini a tendina (sotto la piega) */
  document.querySelectorAll('.ahs-fcard > img, .ahs-ed__media, .ah-ritual .ah-card > img').forEach((el) => {
    if (el.getBoundingClientRect().top < innerHeight) return;
    el.setAttribute('data-ah-clip', '');
    reveal(el);
  });

  /* ---------- bottoni magnetici ---------- */
  if (fine && !reduce) {
    document.querySelectorAll('[data-ah-magnetic], .ahs-b1, .ahs-end .ahs-b, .product-information .add-to-cart-button').forEach((b) => {
      b.classList.add('ah-mag');
      b.addEventListener('pointermove', (e) => {
        const r = b.getBoundingClientRect();
        const x = (e.clientX - r.left - r.width / 2) / r.width;
        const y = (e.clientY - r.top - r.height / 2) / r.height;
        b.style.setProperty('--mx', (x * 10).toFixed(2) + 'px');
        b.style.setProperty('--my', (y * 8).toFixed(2) + 'px');
      });
      b.addEventListener('pointerleave', () => { b.style.setProperty('--mx', '0px'); b.style.setProperty('--my', '0px'); });
    });
  }

  /* ---------- palco hero ---------- */
  const stage = reduce ? null : document.querySelector('[data-ah-stage]');
  let stageVisible = true;
  if (stage) {
    let tx = 0, ty = 0, cx = 0, cy = 0;
    if (fine) {
      stage.addEventListener('pointermove', (e) => {
        const r = stage.getBoundingClientRect();
        tx = (e.clientX - r.left) / r.width - 0.5;
        ty = (e.clientY - r.top) / r.height - 0.5;
      });
      stage.addEventListener('pointerleave', () => { tx = 0; ty = 0; });
    }
    const vis = io(([e]) => { stageVisible = e.isIntersecting; }, { threshold: 0 });
    vis && vis.observe(stage);

    /* nebbia: particelle morbide che salgono */
    const cv = stage.querySelector('[data-ah-mist]');
    let ctx = null, parts = [], sprite = null, W = 0, H = 0;
    const dpr = Math.min(1.5, window.devicePixelRatio || 1);
    const resize = () => {
      if (!cv) return;
      W = cv.clientWidth; H = cv.clientHeight;
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    if (cv) {
      sprite = document.createElement('canvas'); sprite.width = sprite.height = 128;
      const s = sprite.getContext('2d');
      const g = s.createRadialGradient(64, 64, 0, 64, 64, 64);
      g.addColorStop(0, 'rgba(255,236,200,0.55)'); g.addColorStop(0.45, 'rgba(255,226,180,0.16)'); g.addColorStop(1, 'rgba(255,226,180,0)');
      s.fillStyle = g; s.fillRect(0, 0, 128, 128);
      resize(); addEventListener('resize', resize, { passive: true });
      const n = fine ? 34 : 10; // 01/10: su telefono 10 particelle (prima 18)
      for (let i = 0; i < n; i++) parts.push({ x: Math.random(), y: Math.random(), r: 40 + Math.random() * 140, v: 0.00012 + Math.random() * 0.00035, a: 0.25 + Math.random() * 0.5, d: Math.random() * Math.PI * 2 });
    }

    let frame = 0;
    const tick = (t) => {
      requestAnimationFrame(tick);
      if (!stageVisible || document.hidden) return;
      if (!fine && (frame++ & 1)) return; // 01/10: su telefono 30 fps invece di 60
      cx = lerp(cx, tx, 0.06); cy = lerp(cy, ty, 0.06);
      const r = stage.getBoundingClientRect();
      const sp = clamp(-r.top / Math.max(1, r.height), 0, 1);
      setVar(stage, '--px', cx.toFixed(3));
      setVar(stage, '--py', cy.toFixed(3));
      setVar(stage, '--sp', sp.toFixed(3));
      if (ctx) {
        ctx.clearRect(0, 0, W, H);
        ctx.globalCompositeOperation = 'lighter';
        for (const p of parts) {
          p.y -= p.v * 16; if (p.y < -0.2) { p.y = 1.15; p.x = Math.random(); }
          const x = (p.x + Math.sin(t / 4000 + p.d) * 0.03 + cx * 0.02) * W;
          const y = p.y * H;
          ctx.globalAlpha = p.a * (0.35 + 0.65 * Math.sin(Math.PI * clamp(p.y, 0, 1)));
          ctx.drawImage(sprite, x - p.r, y - p.r, p.r * 2, p.r * 2);
        }
      }
    };
    afterLoad(tick);
  }

  /* ---------- racconto fissato ---------- */
  document.querySelectorAll('[data-ah-story]').forEach((st) => {
    const n = Number(st.dataset.count || 3);
    st.classList.add('is-pinned');
    let last = -1;
    const panels = [...st.querySelectorAll('.ahs-story__panel')];
    const set = (i) => {
      if (i === last) return; last = i;
      st.dataset.active = String(i);
      panels.forEach((p, k) => {
        const on = k === i;
        p.classList.toggle('is-on', on);
        p.toggleAttribute('inert', !on);
      });
    };
    set(0);
    let near = true;
    const nearObs = io(([e]) => { near = e.isIntersecting; }, { rootMargin: '200px 0px' });
    nearObs && nearObs.observe(st);
    const loop = () => {
      requestAnimationFrame(loop);
      if (!near || document.hidden) return;
      const r = st.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight) return;
      const p = clamp(-r.top / Math.max(1, r.height - innerHeight), 0, 1);
      setVar(st, '--p', p.toFixed(3));
      set(Math.min(n - 1, Math.floor(p * n * 0.999)));
    };
    afterLoad(loop);
    st.querySelectorAll('[data-ah-goto]').forEach((b) => b.addEventListener('click', () => {
      const r = st.getBoundingClientRect(); const k = Number(b.dataset.ahGoto);
      const y = scrollY + r.top + (r.height - innerHeight) * ((k + 0.5) / n);
      scrollTo({ top: y, behavior: 'smooth' });
    }));
  });

  /* ---------- fascia nomi ---------- */
  const bands = reduce ? [] : [...document.querySelectorAll('[data-ah-marquee]')];
  if (bands.length) {
    let lastY = scrollY, vel = 0, off = 0;
    const widths = new Map();
    const seen = new Set();
    const bandObs = io((es) => es.forEach((e) => (e.isIntersecting ? seen.add(e.target) : seen.delete(e.target))), { rootMargin: '100px 0px' });
    if (bandObs) bands.forEach((b) => bandObs.observe(b)); else bands.forEach((b) => seen.add(b));
    const measure = () => bands.forEach((b) => widths.set(b, b.firstElementChild ? b.firstElementChild.scrollWidth / 2 : 1));
    addEventListener('resize', measure, { passive: true });
    const run = () => {
      requestAnimationFrame(run);
      const dy = scrollY - lastY; lastY = scrollY;
      if (!seen.size || document.hidden) return;
      vel = lerp(vel, dy, 0.1);
      off += 0.35 + Math.abs(vel) * 0.6;
      seen.forEach((b) => {
        const w = widths.get(b) || 1;
        const x = -(off % w);
        setVar(b, '--mq', x.toFixed(1) + 'px');
        setVar(b, '--sk', clamp(vel * -0.25, -8, 8).toFixed(1) + 'deg');
      });
    };
    afterLoad(() => { measure(); run(); });
  }
})();

/* ---------- Duft-Finder ---------- */
(() => {
  const root = document.querySelector('[data-ah-finder]');
  if (!root) return;
  let data;
  try { data = JSON.parse(root.querySelector('[data-df-data]').textContent); } catch (e) { return; }
  const lang = root.dataset.lang === 'bg' ? 'bg' : (root.dataset.lang === 'en' ? 'en' : (root.dataset.lang === 'hu' ? 'hu' : (root.dataset.lang === 'fr' ? 'fr' : (root.dataset.lang === 'sk' ? 'sk' : (root.dataset.lang === 'nl' ? 'nl' : 'de')))));
  const ui = data.ui[lang];
  const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  // QA 24/09: stesso formato del money format Shopify su entrambi i mercati ("3.227,00 €").
  // bg-BG non raggruppa le migliaia a 4 cifre ("3227,00 €") e usa lo spazio come separatore.
  let fmt = new Intl.NumberFormat(lang === 'fr' ? 'fr-FR' : lang === 'sk' ? 'sk-SK' : lang === 'nl' ? 'nl-NL' : 'de-DE', { style: 'currency', currency: 'EUR' });
  if (lang === 'en') { try { fmt = new Intl.NumberFormat('en-' + ((window.Shopify && Shopify.country) || 'IE'), { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }); } catch (e) {} }
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const flag = root.querySelector('[data-df-done]');
  const doneTxt = flag ? flag.dataset.dfDone : '✓';
  const naTxt = flag ? flag.dataset.dfNa : '';
  root.querySelectorAll('[data-df-t]').forEach((el) => { el.textContent = ui[el.dataset.dfT] || ''; });
  const screen = root.querySelector('[data-df-screen]');
  const track = (name, detail) => {
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish(name, detail || {}); } catch (e) {}
    try { window.gtag && gtag('event', name, detail || {}); } catch (e) {}
    try { window.dataLayer && window.dataLayer.push(Object.assign({ event: name }, detail || {})); } catch (e) {}
  };
  const answers = {};
  const cache = {};
  const getP = (h) => cache[h] || (cache[h] = fetch(base + 'products/' + h + '.js', { headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : null)).catch(() => null));
  const setProgress = (n) => { root.dataset.step = String(n); };

  const swap = (htmlStr) => {
    screen.classList.remove('is-in');
    screen.innerHTML = htmlStr;
    setTimeout(() => screen.classList.add('is-in'), 30);
    const f = screen.querySelector('button, a');
    if (f && root.dataset.started) f.focus({ preventScroll: true });
  };

  const start = () => {
    root.dataset.mode = 'intro';
    const meta = lang === 'bg' ? ['3 въпроса', '30 секунди', 'Лична препоръка'] : (lang === 'hu' ? ['3 kérdés', '30 másodperc', 'Személyes ajánlás'] : lang === 'fr' ? ['3 questions', '30 secondes', 'Recommandation personnelle'] : lang === 'sk' ? ['3 otázky', '30 sekúnd', 'Osobné odporúčanie'] : lang === 'nl' ? ['3 vragen', '30 seconden', 'Persoonlijk advies'] : lang === 'en' ? ['3 questions', '30 seconds', 'Personal recommendation'] : ['3 Fragen', '30 Sekunden', 'Persönliche Empfehlung']);
    swap(`<button type="button" class="ahs-b ahs-b1 ahs-df__start" data-df-go="0" data-ah-magnetic><span>${esc(ui.start)}</span> <span aria-hidden="true">→</span></button>
      <ul class="ahs-df__meta">${meta.map((m) => `<li>${esc(m)}</li>`).join('')}</ul>`);
    setProgress(0);
  };

  const ask = (i) => {
    const q = data.questions[i][lang];
    setProgress(i);
    swap(`<p class="ahs-df__step">${esc(ui.step.replace('[n]', i + 1))}</p>
      <h3 class="ahs-df__q">${esc(q.title)}</h3>
      <div class="ahs-df__opts">${q.options.map((o, k) => `<button type="button" class="ahs-df__opt" data-df-a="${esc(o.id)}" style="--k:${k}"><span class="ahs-df__n" aria-hidden="true">${String(k + 1).padStart(2, '0')}</span><span class="ahs-df__on">${esc(o.label)}</span>${o.sub ? `<span class="ahs-df__os">${esc(o.sub)}</span>` : ''}<span class="ahs-df__arr" aria-hidden="true">→</span></button>`).join('')}</div>
      ${i > 0 ? `<button type="button" class="ahs-df__back" data-df-go="${i - 1}">← ${esc(ui.back)}</button>` : ''}`);
    root.dataset.q = i;
    root.dataset.mode = 'ask';
  };

  const match = () => data.results.find((r) => ['q1', 'q2', 'q3'].every((k) => !r.when[k] || r.when[k] === '*' || r.when[k] === answers[k]));

  const card = (p, cls, label) => {
    if (!p) return '';
    const v = p.variants.find((x) => x.available) || p.variants[0];
    const img = p.featured_image ? (p.featured_image.startsWith('//') ? 'https:' + p.featured_image : p.featured_image) : '';
    const src = img ? img + (img.includes('?') ? '&' : '?') + 'width=500' : '';
    let unit = '';
    if (v.unit_price && v.unit_price_measurement) {
      const m = v.unit_price_measurement; const u = m.reference_unit || '';
      unit = ` · ${fmt.format(v.unit_price / 100)}/${m.reference_value && m.reference_value !== 1 ? m.reference_value + ' ' : ''}${lang === 'bg' ? ({ l: 'л', kg: 'кг', ml: 'мл', g: 'г' }[u] || u) : u}`;
    }
    return `<div class="ahs-df__card ${cls}">
      ${label ? `<p class="ahs-df__cl">${esc(label)}</p>` : ''}
      <a class="ahs-df__ci" href="${esc(p.url || base + 'products/' + p.handle)}">${src ? `<img src="${esc(src)}" alt="" loading="lazy" width="500" height="500">` : ''}</a>
      <div class="ahs-df__cb">
        <a class="ahs-df__cn" href="${esc(p.url || base + 'products/' + p.handle)}">${esc(p.title)}</a>
        <p class="ahs-df__cp">${fmt.format(v.price / 100)}<small>${esc(unit)}</small></p>
        ${v.available ? `<form class="ah-add-form" action="${esc(base)}cart/add" method="post"><input type="hidden" name="id" value="${v.id}"><input type="hidden" name="quantity" value="1"><button type="submit" class="ahs-add" data-done="${esc(doneTxt)}" data-na="${esc(naTxt)}">${esc(ui.add)}</button></form>` : ''}
      </div></div>`;
  };

  const result = async () => {
    setProgress(3);
    root.dataset.mode = 'result';
    const r = match();
    if (!r) return start();
    screen.classList.remove('is-in');
    screen.setAttribute('aria-busy', 'true');
    const [m, a, k] = await Promise.all([getP(r.main), r.alt ? getP(r.alt) : null, r.kit ? getP(r.kit) : null]);
    screen.removeAttribute('aria-busy');
    if (!m) return start();
    swap(`<p class="ahs-df__step">${esc(ui.result_title)}</p>
      <p class="ahs-df__why">${esc((r.why && r.why[lang]) || '')}</p>
      ${card(m, 'ahs-df__card--main', '')}
      <div class="ahs-df__more">${card(a, '', ui.alt_label)}${card(k, '', ui.kit_label)}</div>
      <button type="button" class="ahs-df__back" data-df-go="0">↺ ${esc(ui.restart)}</button>`);
    window.dispatchEvent(new CustomEvent('ah:finder-result', { detail: { main: r.main } }));
    track('ah_quiz_result', { lang, use: answers.q1, scent: answers.q2, format: answers.q3, product: r.main });
  };

  root.addEventListener('submit', (e) => { if (e.target.closest('.ah-add-form')) track('ah_quiz_add_to_cart', { lang, product: (e.target.closest('.ahs-df__card') || {}).querySelector ? e.target.closest('.ahs-df__card').querySelector('.ahs-df__cn').textContent : '' }); }, true);
  root.addEventListener('click', (e) => {
    const go = e.target.closest('[data-df-go]');
    if (go) { if (!root.dataset.started) track('ah_quiz_start', { lang }); root.dataset.started = '1'; ask(Number(go.dataset.dfGo)); return; }
    const opt = e.target.closest('[data-df-a]');
    if (opt) {
      const i = Number(root.dataset.q || 0);
      answers['q' + (i + 1)] = opt.dataset.dfA;
      opt.classList.add('is-picked');
      setTimeout(() => (i < 2 ? ask(i + 1) : result()), 180);
    }
  });
  // precarica i prodotti piu' probabili quando la sezione si avvicina
  if ('IntersectionObserver' in window) {
    const o = new IntersectionObserver(([en]) => { if (en.isIntersecting) { o.disconnect(); ['oil-lavender-15ml', 'oil-lemon-15ml', 'oil-peppermint-15ml'].forEach(getP); } }, { rootMargin: '400px' });
    o.observe(root);
  }
  start();
})();
